// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2x7I6","questions":"styles_questions__3hzxC","footer":"styles_footer__1Tj1j"};